import React from 'react';
import { FaWhatsapp } from "react-icons/fa";

const PromoCard = ({ imageUrl, description, whatsappNumber, message }) => {
  const handleWhatsAppClick = () => {
    const url = `https://wa.me/${whatsappNumber}?text=${encodeURIComponent(message)}`;
    window.open(url, '_blank');
  };

  return (
    <div className="w-72 sm:w-full rounded-lg shadow-lg p-2">
      <div
        className="rounded-lg overflow-hidden h-64 shadow-lg"
        style={{ backgroundImage: `url(${imageUrl})`, backgroundSize: 'cover', backgroundPosition: 'center' }}
      />

      <div className="mt-4 flex flex-col justify-center items-center">
        <div className="bg-black bg-opacity-60 text-white p-2.5 rounded-lg text-center w-full">
          {description}
        </div>
        <button
          onClick={handleWhatsAppClick}
          className="bg-[#25D366] text-white border-none rounded-md px-5 py-2.5 mt-2.5 cursor-pointer text-base font-bold hover:bg-[#128C7E] transition-colors flex items-center"
        >
          <FaWhatsapp className="mr-2" />
          WhatsApp Us
        </button>
      </div>
    </div>
  );
};

export default PromoCard;